import '.././popup.common.css'
import styles from './Style.module.css'
import CustomModal from '../../Modal/CustomModal'
import BorderedButton from '../../Buttons/BorderedButton'
import PrimaryButton from '../../Buttons/PrimaryButton'
import { useEffect, useRef, useState } from 'react'
import { focusRefWhenReady } from '../../../Utils/utils'

const SaleNotePopup = ({onClose, addSaleNote, editableNote, isProcessing = false, apiError = ""}) => {
    const textareaRef = useRef(null);
    const [saleNote, setSaleNote] = useState(editableNote || '');
    const [error, setError] = useState('');

    useEffect(() => focusRefWhenReady(textareaRef), []);

    useEffect(() => {
        if (apiError) {
            setError(apiError);
        }
    }, [apiError]);
        
    const handleTextareaInput = (e) => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
        let newValue = e.target.value;
        // Remove leading spaces
        newValue = newValue.trimStart();
        setSaleNote(newValue);
        // Clear error when user starts typing
        if (error) {
            setError('');
        }
    };

    const handleConfirmClick = () => {
        // Allow empty string but ensure it's not null
        const noteToSave = saleNote === null ? '' : saleNote;
        addSaleNote(noteToSave);
    };

  return (
    <CustomModal
        show={true}
        onHide={onClose}
        // hideCloseButton={true}
    >
        <div className={`popup ${styles.saleNotePopup}`}>	
            <div className="header">
                <h2>Add Sale Notes</h2>
            </div>

            <div className={`${styles.saleNotePopup} body`}>
                <textarea
                    ref={textareaRef}
                    autoFocus
                    value={saleNote}
                    onChange={handleTextareaInput}
                    placeholder="Enter sale notes..."
                    rows={1}
                    className={`${styles.textarea} textarea`}
                />
                {error && (
                    <div className={styles.errorMessage}>
                        {error}
                    </div>
                )}
            </div>

            <div className="footer">
                <BorderedButton
                    text="Cancel"
                    onClick={onClose}
                />
                <PrimaryButton
                    text={isProcessing ? "Processing..." : "Confirm"}
                    onClick={handleConfirmClick}
                    disabled={isProcessing}
                />
            </div>
        </div>
  </CustomModal>
  )
}

export default SaleNotePopup